module.exports = __webpack_public_path__ + "img/phone-using-png.d2b11aa5.png";